import React from 'react';
import './PressPreviewCard.scss';

/**
 * Renders Press Preview card inner content
 * @param {array} logos
 * @returns {JSX.Element}
 * @constructor
 */
const PressPreviewCard = ({ logos }) => (
  <div className="c-press-preview-card">
    <div className="c-press-preview-card__inner">
      {logos.map((logo) => (
        <div className="c-press-preview-card__logo">
          <img src={logo.logoUrl} alt={logo.logoAlt} />
        </div>
      ))}
    </div>
  </div>
);

export default PressPreviewCard;
